import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { IconProvider } from './components/IconProvider';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <IconProvider>
      <App />
    </IconProvider>
  </React.StrictMode>,
  document.getElementById('root')
);